import * as React from 'react';
import { Component } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  ModalFooter,
  Button,
  Label,
  FormGroup,
  InputGroup,
  InputGroupText,
} from 'reactstrap';
import i18n from '@/utils/i18n';
import { LayoutStoreInstance } from '../../LayoutStore';
import { Communicator } from '../../tools/Communication';
import { LoadingContainer } from '../../components/Layout';
import { Link } from 'react-router-dom';
import { FaUsers } from 'react-icons/fa';

interface AddSpecialUserModalProps {
  onClose: () => void;
}

type SpecialUserType = 'internalconsumer' | 'admin' | 'catering';

interface AddSpecialUserModalState {
  name: string;
  email: string;
  type: SpecialUserType;
  isSending: boolean;
  accountCreated: boolean;
  createdUserId: string | null;
  passwordLink: string | null;
}

export class AddSpecialUserModal extends Component<
  AddSpecialUserModalProps,
  AddSpecialUserModalState
> {
  constructor(props: AddSpecialUserModalProps) {
    super(props);
    this.state = {
      name: '',
      email: '',
      type: 'internalconsumer',
      isSending: false,
      accountCreated: false,
      createdUserId: null,
      passwordLink: null,
    };
  }

  submit() {
    this.setState({ isSending: true });

    let username = `VYTAL${
      this.state.type == 'internalconsumer' ? 'internal' : this.state.type
    }_${this.state.name}`;

    if (
      this.state.name.toLowerCase().startsWith('vytal') ||
      this.state.name.toLowerCase().startsWith('internal') ||
      this.state.name.toLowerCase().startsWith('admin') ||
      this.state.name.toLowerCase().startsWith('catering')
    ) {
      var confirmation = prompt(
        `Are you really sure the user name name should be '${username}'? It looks like you made a mistake. To confirm you are really sure about this name, please type in the name '${username}' again.`,
      );
      if (confirmation != username) {
        alert(
          'You typed in a different name. Please check the form entries and try again.',
        );
        this.setState({ isSending: false });
        return;
      }
    }

    Communicator.PostData('/Users/AddSpecialUser', {
      name: username,
      email: this.state.email,
      type: this.state.type,
    })
      .then(async (data: Response) => {
        this.setState({ isSending: false });
        LayoutStoreInstance.setSuccess(i18n.t('Users:userCreatedSuccessfully'));

        const response = await data.json();
        if (response.setPasswordLink || response.createdUserId) {
          this.setState({
            accountCreated: true,
            passwordLink: response.setPasswordLink,
            createdUserId: response.createdUserId,
          });
        } else {
          this.props.onClose();
        }
      })
      .catch(async (data: Response) => {
        LayoutStoreInstance.setError(
          'Error creating user: ' + (await data.text()),
        );
        this.setState({ isSending: false });
      });
  }

  render() {
    return (
      <Modal size="lg" isOpen={true} toggle={this.props.onClose}>
        <ModalHeader>{i18n.t('Users:addSpecialUser')}</ModalHeader>
        <ModalBody>
          {this.state.accountCreated ? (
            <div>
              <p>
                The user was created successfully. You can set the password in
                the "Password" Tab.
              </p>
              <Link
                to={
                  '/users/' + encodeURIComponent(this.state.createdUserId || '')
                }
              >
                <FaUsers /> Created User
              </Link>
              <br />
              <br />

              {this.state.passwordLink && (
                <>
                  <p>Or you can send this link to the user</p>
                  <Input value={this.state.passwordLink || ''} readOnly />
                </>
              )}
            </div>
          ) : (
            <div>
              <FormGroup>
                <Label>
                  <strong>{i18n.t('Common:type')}</strong>
                </Label>
                <select
                  className="form-control"
                  onChange={(e) =>
                    this.setState({ type: e.target.value as SpecialUserType })
                  }
                  value={this.state.type}
                >
                  <option value="internalconsumer">
                    {i18n.t('Users:internalConsumer')}
                  </option>
                  <option value="catering">{i18n.t('Users:catering')}</option>
                  <option value="admin">{i18n.t('Users:admin')}</option>
                </select>
              </FormGroup>
              <FormGroup>
                <Label>
                  <strong>{i18n.t('Common:name')}</strong>{' '}
                  {i18n.t('Users:nameInstructions')}
                </Label>
                <InputGroup>
                  <InputGroupText>
                    VYTAL
                    {this.state.type == 'internalconsumer'
                      ? 'internal'
                      : this.state.type}
                    _
                  </InputGroupText>
                  <Input
                    className="form-control"
                    onChange={(e) => this.setState({ name: e.target.value })}
                    value={this.state.name}
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <Label>
                  <strong>{i18n.t('Common:email')}</strong>{' '}
                  {i18n.t('Users:emailInstructions')}
                </Label>
                <Input
                  onChange={(e) => this.setState({ email: e.target.value })}
                  value={this.state.email}
                />
              </FormGroup>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          {this.state.isSending ? (
            <LoadingContainer />
          ) : (
            [
              !this.state.accountCreated ? (
                <Button
                  key="create"
                  color="primary"
                  className="text-white"
                  onClick={() => this.submit()}
                  disabled={this.state.isSending || !this.state.name}
                >
                  {i18n.t('Common:create')}
                </Button>
              ) : null,
              <Button
                key="close"
                color="secondary"
                onClick={this.props.onClose}
              >
                {i18n.t('Common:close')}
              </Button>,
            ]
          )}
        </ModalFooter>
      </Modal>
    );
  }
}
